import { IAuthStoreSegment } from './auth.interface';

export const authStoreSelector = (state: IAuthStoreSegment) => {
  return state.auth;
};
